window.addEventListener('load', () => {
    const modal = document.querySelector('.modal-container');
    const toggles = document.querySelectorAll('.modal-toggle');
    toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            modal.classList.toggle('active');
        });
    })
})